
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';

import { FeatureName } from './feature';
import { adminReducer } from './reducer';
import { AdminStoreEffects } from './effects';


@NgModule({
	imports: [
		CommonModule,
		StoreModule.forFeature(FeatureName, adminReducer),
		EffectsModule.forFeature([AdminStoreEffects])
	]
})

// eslint-disable-next-line @typescript-eslint/no-extraneous-class
export class AdminStoreModule { }
